import { Component } from '@angular/core';
import {SnackbarService} from 'ngx-snackbar';
import {SharedServiceService} from 'app/services/shared-service.service';
import { interval } from 'rxjs';

@Component({
  selector: 'app-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.scss']
})
export class SnackBarComponent {
  success = true;
  msg = '';
  timeOut = 5000;
  green = '#2d9254';
  red = '#d30700';
  selectedColor = '';
  showFilter = false;
  timeInterval;
  constructor(private snackbarService: SnackbarService, private sharedService: SharedServiceService) {
    this.selectedColor = this.red;
  }

  checkPopUpBottom() {
    setTimeout(() => this.sharedService.handlePopupBottom(), 2);
  }
  closeSnack() {
    this.showFilter = false;
    this.checkPopUpBottom();
    clearInterval(this.timeInterval);
  }
  addSnack(msg, status) {
    let color = this.red;
    const message = `<div class="mySnack"><p>${msg}</p></div>`;
    if (status) {
      color = this.green;
    } else {
      color = this.red;
    }
    this.snackbarService.add({
      msg: message,
      timeout: Number(this.timeOut),
      background: color,
      action: {
        text: ' ',
        onClick: (snack) => {
          this.undo();
        },
      }
    });
  }
  undo() {
  }
}
